/** Free basemap tile presets for PlannerLeafletMap (no API key). */

export const MAP_BASEMAPS = {
  osm: {
    id: 'osm',
    label: 'Standard',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  },
  gray: {
    id: 'gray',
    label: 'Light gray',
    // Esri World Light Gray — minimal gray canvas
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    attribution:
      'Tiles &copy; <a href="https://www.esri.com/">Esri</a> &mdash; Esri, DeLorme, NAVTEQ',
    /** Optional label overlay for place/street names */
    labels: {
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
      attribution: '',
    },
  },
};

/** Active default basemap */
export const DEFAULT_BASEMAP = MAP_BASEMAPS.gray;
